module.exports = __webpack_public_path__ + "static/media/blueVert.6ff2ab0a.png";